/* fizzy-mission-slideshow-compact — vanilla crossfade slideshow with autoplay,
   progress-bar pagination, and caret nav. No Swiper. */
(function () {
  'use strict';

  var prefersReduced = window.matchMedia &&
    window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  function initRoot(root) {
    if (root.__fmscInit) return;
    root.__fmscInit = true;

    var slides = Array.prototype.slice.call(root.querySelectorAll('[data-fmsc-slide]'));
    var pages = Array.prototype.slice.call(root.querySelectorAll('[data-fmsc-page]'));
    var prevBtn = root.querySelector('[data-fmsc-prev]');
    var nextBtn = root.querySelector('[data-fmsc-next]');
    var count = slides.length;
    if (count <= 1) return;

    var delay = parseInt(root.getAttribute('data-delay'), 10) || 5000;
    var autoplay = root.getAttribute('data-autoplay') === 'true' && !prefersReduced;

    var current = 0;
    var rafId = null;
    var startTs = 0;
    var paused = false;

    function setActive(index) {
      index = (index + count) % count;
      current = index;

      slides.forEach(function (slide, i) {
        slide.classList.toggle('is-active', i === index);
      });
      pages.forEach(function (page, i) {
        page.classList.toggle('is-active', i === index);
        var bar = page.querySelector('[data-fmsc-bar]');
        if (!bar) return;
        // reset every bar; active one will be driven by the progress loop
        page.style.setProperty('--fmsc-progress', i < index ? '1' : '0');
      });
    }

    function tick(ts) {
      if (!startTs) startTs = ts;
      if (paused) { startTs = ts; rafId = requestAnimationFrame(tick); return; }

      var elapsed = ts - startTs;
      var progress = Math.min(elapsed / delay, 1);
      var activePage = pages[current];
      if (activePage) activePage.style.setProperty('--fmsc-progress', String(progress));

      if (progress >= 1) {
        startTs = ts;
        setActive(current + 1);
      }
      rafId = requestAnimationFrame(tick);
    }

    function startAutoplay() {
      if (!autoplay) return;
      stopAutoplay();
      startTs = 0;
      rafId = requestAnimationFrame(tick);
    }

    function stopAutoplay() {
      if (rafId) cancelAnimationFrame(rafId);
      rafId = null;
    }

    function goTo(index) {
      setActive(index);
      startTs = 0;
    }

    if (prevBtn) prevBtn.addEventListener('click', function () {
      goTo(current - 1); startAutoplay();
    });
    if (nextBtn) nextBtn.addEventListener('click', function () {
      goTo(current + 1); startAutoplay();
    });
    pages.forEach(function (page) {
      page.addEventListener('click', function () {
        var idx = parseInt(page.getAttribute('data-index'), 10) || 0;
        goTo(idx); startAutoplay();
      });
    });

    // Pause on hover / focus / offscreen
    root.addEventListener('mouseenter', function () { paused = true; });
    root.addEventListener('mouseleave', function () { paused = false; });
    root.addEventListener('focusin', function () { paused = true; });
    root.addEventListener('focusout', function () { paused = false; });

    document.addEventListener('visibilitychange', function () {
      paused = document.hidden;
    });

    if ('IntersectionObserver' in window) {
      var io = new IntersectionObserver(function (entries) {
        entries.forEach(function (e) {
          if (e.isIntersecting) startAutoplay();
          else stopAutoplay();
        });
      }, { threshold: 0.2 });
      io.observe(root);
    } else {
      startAutoplay();
    }

    setActive(0);
    startAutoplay();
  }

  function initAll() {
    document.querySelectorAll('[data-fmsc]').forEach(initRoot);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll);
  } else {
    initAll();
  }

  // Shopify theme editor support
  document.addEventListener('shopify:section:load', function (e) {
    var root = e.target.querySelector('[data-fmsc]');
    if (root) initRoot(root);
  });
})();
